import {Component, EventEmitter, Input, OnInit, Optional, Output, SimpleChanges} from '@angular/core';
import {Mode} from '@shared/enums/mode.enum';
import {MenuNode} from '@modules/administration/menus/interfaces/menu.model';
import {MenuType} from '@modules/administration/menus/menu.constant';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MenuService} from '@modules/administration/menus/services/menu.service';
import {NzModalRef} from 'ng-zorro-antd/modal';
import {NotificationService} from '@shared/services/notification.service';
import {StructureUtils} from '@shared/utils/structure-utils.class';
import {BaseResponse} from '@core/models/base-response.model';
import {MESSAGE_CODE} from '@shared/constants/message-code.constant';
import { VALIDATORS } from './config-menu.validator';
import * as _ from "lodash";
@Component({
  selector: 'app-config-menu',
  templateUrl: './config-menu.component.html',
  styleUrls: ['./config-menu.component.css']
})
export class ConfigMenuComponent implements OnInit {

  readonly VALIDATORS = VALIDATORS;
  readonly MODE = Mode;

  @Input() data: MenuNode;
  @Input() menus: MenuNode[] = [];
  _menus: MenuNode[] = [];
  @Input() mode: Mode = Mode.ADD;
  @Input() menuType: number = MenuType.LEFT_SIDEBAR;
  @Output() reloadEvent: EventEmitter<any> = new EventEmitter<any>();
  expandKeys = [];

  form: FormGroup;
  isSubmitted = false;

  constructor(
    private fb: FormBuilder,
    private notiService: NotificationService,
    private menuService: MenuService,
    @Optional() protected modalRef: NzModalRef
  ) {
    this.form = this.fb.group({
      id: [null],
      parentId: [null],
      name: [null, [Validators.required]],
      description: [null],
      url: [null],
      orderPriority: [0],
      icon: [null],
      enable: [true],
      menuType: [null],
      menuCode: [null, [Validators.required]]
    });
  }

  ngOnInit(): void {
    this._menus = _.cloneDeep(this.menus);
    if (this.data) {
      StructureUtils.removeNodeInTreeArray(this._menus, this.data.id, 'id');
    }
    this.f.menuType.setValue(this.menuType);

    if (this.data) {
      this.menuService.getMenu(this.data.id).subscribe((res: BaseResponse<any, any>) => {
        if (res != null && res.messageCode === MESSAGE_CODE.SUCCESS) {
          this.data = res.data;
          this.patchData();
        } else this.notiService.error(BaseResponse.getMessage(res));
      }, error => {
        this.notiService.error(BaseResponse.getMessage(error));
      });
    }

  }


  get f() {
    return this.form.controls;
  }

  patchData() {
    this.form.patchValue(this.data);
    this.f.menuCode.disable();
    this.f.parentId.setValue(this.data.parentId?.toString());
    StructureUtils.expandNode(this.menus, this.data.parentId, 'id', this.expandKeys = []);
    this.onChanges();
  }

  onChanges() {
    this.f.parentId.valueChanges.subscribe((value) => {
      StructureUtils.expandNode(this.menus, value, 'id', this.expandKeys = []);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data?.currentValue) {
      this.form.reset();
      this.patchData();
      this._menus = _.cloneDeep(this.menus);
      StructureUtils.removeNodeInTreeArray(this._menus, this.data.id, 'id');
    }
  }

  configMenu() {
    this.isSubmitted = true;
    if (this.form.valid) {
      this.mode == Mode.ADD ? this.create(this.form.value) : this.update(this.form.getRawValue());
    }
  }

  private create(request: any) {
    this.menuService.addMenu(request).subscribe((res: BaseResponse<any, any>) => {
      if (res?.messageCode === MESSAGE_CODE.SUCCESS) {
        this.isSubmitted = false;
        this.notiService.success(res.message);
        this.reloadEvent.emit(true);
        this.modalRef?.destroy({refresh: true, key: res.data.id});
      }else this.notiService.error(BaseResponse.getMessage(res));
    }, error => {
      this.isSubmitted = false;
      this.notiService.error(BaseResponse.getMessage(error));
    });
  }

  private update(request: any) {
    this.menuService.updateMenu(request).subscribe((res: BaseResponse<any, any>) => {
      if (res?.messageCode === MESSAGE_CODE.SUCCESS) {
        this.isSubmitted = false;
        this.notiService.success(res.message);
        this.reloadEvent.emit({refresh: true, key: res.data.id});
      } else this.notiService.error(BaseResponse.getMessage(res));
    }, error => {
      this.isSubmitted = false;
      this.notiService.error(BaseResponse.getMessage(error));
    });
  }

  cancel() {
    if (this.mode == Mode.ADD) {
      this.modalRef?.destroy();
    }
    this.form.reset();
    this.patchData();
  }
}
